import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router-dom";
import mr from "../Scripts"; // Script file from Stack template
import BlockUi from "react-block-ui";
import { Loader } from "react-loaders";
import GuestAlert from "../Components/Common/GuestAlert";
import TopBar from "../Components/Common/TopBar";
import NavMenu from "../Components/Common/NavMenu";
// import Footer from "../Components/Common/Footer"
import { Container as Content } from "../Components/Common/Container";
import { BackToTop } from "../Components/Common/BackToTop";
import ServerErrorModal from "../Components/Modals/ServerError";
import AlertModal from "../Components/Modals/Alert";
import EligibilityModal from "../Components/Modals/EligibilityModal";
import WizardInProgressModal from "../Components/Modals/WizardInProgressModal";
import { getNivoSlider } from "../Store/Metadata/Actions";
import { getTopics } from "../Store/Topics/Actions";
import { getCategories, getAccessories, getServices, getNewProducts } from "../Store/Catalog/Actions";
import { getCart, clearCart } from "../Store/Cart/Actions";
import { toggleBlockingStatus } from "../Store/Status/Actions";
import { resetOrderConfirmation } from "../Store/Checkout/Actions";
import ChatSoonModal from "../Components/Modals/ChatSoon";
import Chat from "../Components/Chat/Chat";
import ReactGA from "react-ga4";

class LayoutMain extends Component {
    componentWillMount() {
        const { getNivoSlider, getTopics, getCategories, getAccessories, getServices, getNewProducts, getCart, isAuthenticated, toggleBlockingStatus, cart, nivoSlider, topics, categories, skipOrderConfirmationReset, orderConfirmation, resetOrderConfirmation, userInfo, location, accessories, services, newProducts, config: { GOOGLE_ANALYTICS_TRACKING_CODE, ACCESSORIES_CATEGORY_ID, SERVICES_CATEGORY_ID } } = this.props;

        if (isAuthenticated) {
            if (!cart.items) {
                getCart();
            }

            if (!topics || topics.length === 0) {
                getTopics();
            }

            if (!nivoSlider || nivoSlider.length === 0) {
                getNivoSlider();
            }

            if (!categories || categories.length === 0) {
                getCategories();
            }

            if (!newProducts || newProducts.length === 0) {
                getNewProducts(true, true, true);
            }

            if (!accessories || accessories.length === 0) {
                getAccessories(ACCESSORIES_CATEGORY_ID, true);
            }

            if (!services || services.length === 0) {
                getServices(SERVICES_CATEGORY_ID);
            }
        } else {
            toggleBlockingStatus(false);
        }

        if (orderConfirmation.checkoutCompleteResponses && !skipOrderConfirmationReset) {
            resetOrderConfirmation();
        }

        // Google Analytics
        // For userId view to set the client Id in user explorer of google analytics
        if (userInfo) {
            ReactGA.initialize(GOOGLE_ANALYTICS_TRACKING_CODE, { gaOptions: { cookieFlags: 'SameSite=Lax;'} });
            ReactGA.set({ userId: userInfo.email || userInfo.employeeId });
        }
    }

    render() {
        const { serverError, blockingStatus, isAuthenticated, userInfo, showGuestAlert } = this.props;
        if (serverError) {
            document.querySelector("#server-error-msg").textContent = serverError;
            $("#server-error-modal").modal("show");
        }

        return (
            <BlockUi tag="div" blocking={blockingStatus} loader={<Loader active type="cube-transition" color="#3097B9"/>}>
                <a id="start"></a>
                {isAuthenticated && userInfo && userInfo.isGuest && showGuestAlert && <GuestAlert/>}
                <TopBar/>
                {/* <SideMenu/>*/}
                {isAuthenticated && <NavMenu isAuthenticated={isAuthenticated}/>}
                <Content children={this.props.children}/>
                {/* <Footer/>*/}
                <BackToTop/>
                <ServerErrorModal/>
                <AlertModal/>
                <EligibilityModal/>
                <WizardInProgressModal/>
                {/* <ChatSoonModal/> */}
                {/* <Chat/> */}
            </BlockUi>
        );
    }
}

function mapStateToProps(state) {
    return {
        blockingStatus: state.blockingStatus,
        serverError: state.serverError,
        wizardCurrentStep: state.wizardCurrentStep,
        isAuthenticated: state.isAuthenticated,
        userInfo: state.userInfo,
        showGuestAlert: state.guestAlertStatus,
        cart: state.cart,
        nivoSlider: state.nivoSlider,
        topics: state.topics,
        categories: state.categories,
        orderConfirmation: state.orderConfirmation,
        accessories: state.accessories,
        services: state.services,
        newProducts: state.newProducts,
        config: state.config
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getTopics: getTopics,
        getNivoSlider: getNivoSlider,
        getCategories: getCategories,
        getAccessories: getAccessories,
        getServices: getServices,
        getNewProducts: getNewProducts,
        getCart: getCart,
        clearCart: clearCart,
        toggleBlockingStatus: toggleBlockingStatus,
        resetOrderConfirmation: resetOrderConfirmation
    }, dispatch);
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(LayoutMain));